"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const expressions_ui_1 = require("@mwater/expressions-ui");
// Control to edit the global filters (_managed_by and admin_region)
class MWaterGlobalFiltersComponent extends react_1.default.Component {
    handleRegionsChange = (regions) => {
        // Remove existing filter
        const globalFilters = lodash_1.default.filter(this.props.globalFilters || [], (gf) => !(gf.op === "within any" && gf.columnId === "admin_region"));
        // Add new filter if present
        if (regions && regions.length > 0) {
            globalFilters.push({
                columnId: "admin_region",
                columnType: "id",
                op: "within any",
                exprs: [{ type: "literal", valueType: "id[]", idTable: "admin_regions", value: regions }]
            });
        }
        this.props.onChange(globalFilters);
    };
    handleManagedByChange = (managedBy) => {
        // Remove existing filter
        const globalFilters = lodash_1.default.filter(this.props.globalFilters || [], (gf) => !(gf.op === "within" && gf.columnId === "_managed_by"));
        // Add new filter if present
        if (managedBy) {
            globalFilters.push({
                columnId: "_managed_by",
                columnType: "id",
                op: "within",
                exprs: [{ type: "literal", valueType: "id", idTable: "subjects", value: "group:" + managedBy }]
            });
        }
        this.props.onChange(globalFilters);
    };
    render() {
        // Find managed by
        let adminRegions, managedBy;
        const managedByEntry = lodash_1.default.find(this.props.globalFilters || [], (gf) => gf.op === "within" && gf.columnId === "_managed_by");
        if (managedByEntry) {
            managedBy = managedByEntry.exprs[0].value.split(":")[1];
        }
        else {
            managedBy = null;
        }
        // Find admin region
        const adminRegionEntry = lodash_1.default.find(this.props.globalFilters || [], (gf) => gf.op === "within any" && gf.columnId === "admin_region");
        if (adminRegionEntry) {
            adminRegions = adminRegionEntry.exprs[0].value;
        }
        else {
            adminRegions = null;
        }
        return R("div", null, R(ui.FormGroup, { label: T `Only sites managed by`, labelMuted: true }, R(expressions_ui_1.IdLiteralComponent, {
            value: managedBy,
            onChange: this.handleManagedByChange,
            idTable: "groups",
            schema: this.props.schema,
            dataSource: this.props.dataSource,
            placeholder: T `All Organizations`,
            multi: false,
            filter: { type: "field", tableAlias: "main", column: "canManageEntities" }
        })), R(ui.FormGroup, { label: T `Only sites located in`, labelMuted: true }, R(expressions_ui_1.IdLiteralComponent, {
            value: adminRegions,
            onChange: this.handleRegionsChange,
            idTable: "admin_regions",
            schema: this.props.schema,
            dataSource: this.props.dataSource,
            placeholder: T `All Regions`,
            multi: true,
            orderBy: [{ expr: { type: "field", tableAlias: "main", column: "level" }, direction: "asc" }]
        })));
    }
}
exports.default = MWaterGlobalFiltersComponent;
